const RCC_COMMENT_ROLES = new Set(["APR_RCC", "RCC_USER"]);
const APR_DCE_COMMENT_ROLES = new Set(["APR_DCE", "APRDCE"]);

export function isRccCommentRole(role) {
  return RCC_COMMENT_ROLES.has(String(role || "").toUpperCase());
}

export function isAprDceCommentRole(role) {
  const normalized = String(role || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  return APR_DCE_COMMENT_ROLES.has(normalized) || normalized === "APRDCE";
}

export function isAprCommentRole(role) {
  return String(role || "").toUpperCase() === "APR_USER";
}

export function isNdpcViewer(viewerRole) {
  return String(viewerRole || "").toUpperCase() === "NDPC_USER";
}

export function normalizeAprReportRole(user) {
  const reportRole =
    user?.user?.userRoles?.find((role) =>
      ["APR USER", "RCC USER", "APR DCE", "NDPC USER"].includes(role.name),
    )?.name || "";
  return reportRole ? reportRole.replace(/ /g, "_").toUpperCase() : "";
}

export function hasAprDceRole(user) {
  return (user?.user?.userRoles || []).some((role) => isAprDceCommentRole(role?.name));
}

/** NDPC users must not see internal RCC / APR DCE review comments. */
export function filterCommentsForViewer(comments, viewerRole) {
  if (!isNdpcViewer(viewerRole)) {
    return comments;
  }
  return comments.filter(
    (comment) => !isRccCommentRole(comment.userRole) && !isAprDceCommentRole(comment.userRole),
  );
}

/**
 * Personal identifiers must not appear in the final / printed APR.
 * Authors may still show while the report is actively being prepared.
 *
 * Parent props often pass:
 * - assessmentStatus as boolean (true = still editable / not completed)
 * - assessmentStatus1 as boolean (true = not closed)
 * - or a status string via options.assessmentStatus
 */
export function shouldShowCommentAuthorToViewer(comment, viewerRole, options = {}) {
  if (options?.hideAuthorsForFinalReport) return false;

  if (options?.assessmentStatus1 === false) return false;
  if (options?.assessmentStatus === false) return false;

  if (typeof options?.assessmentStatus === "string") {
    const status = options.assessmentStatus.toLowerCase();
    if (status === "completed" || status === "closed") return false;
  }

  if (!isNdpcViewer(viewerRole)) return true;
  return !isAprCommentRole(comment.userRole);
}
